import API_BASE, { withApiCredentials } from "../api";
import { getActiveAwareAuthToken } from "../auth/bootstrapTokens";

export class GearDealsApiError extends Error {
  constructor(message, { status = 0, detail = "" } = {}) {
    super(message);
    this.name = "GearDealsApiError";
    this.status = status;
    this.detail = detail;
  }
}

async function parseJsonResponse(response) {
  try {
    return await response.json();
  } catch {
    return null;
  }
}

function getAuthToken() {
  return getActiveAwareAuthToken(
    typeof window !== "undefined" ? window : undefined
  );
}

function buildError(payload, fallbackMessage, status) {
  const detail =
    typeof payload?.detail === "string" ? payload.detail.trim() : "";
  return new GearDealsApiError(detail || fallbackMessage, {
    status,
    detail,
  });
}

export async function searchGearDeals(
  { query, source = "all", condition = "all", sort = "best_match" },
  options = {}
) {
  const token = getAuthToken();

  const params = new URLSearchParams({
    q: String(query || "").trim(),
    source,
    condition,
    sort,
    source_page:
      typeof window !== "undefined" ? window.location.pathname : "/gear-deals",
  });

  const response = await fetch(
    `${API_BASE}/gear-deals/search?${params}`,
    withApiCredentials({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      signal: options.signal,
    })
  );
  const payload = await parseJsonResponse(response);

  if (!response.ok) {
    throw buildError(payload, "gear_deals_search_failed", response.status);
  }

  return payload || { results: [] };
}

export async function createGearDealClick(
  { provider, offerId, searchEventId, query, sourcePage = "/gear-deals" },
  options = {}
) {
  const token = getAuthToken();

  const response = await fetch(
    `${API_BASE}/gear-deals/click`,
    withApiCredentials({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        provider,
        offerId,
        searchEventId,
        query,
        sourcePage,
      }),
      signal: options.signal,
    })
  );
  const payload = await parseJsonResponse(response);

  if (!response.ok) {
    throw buildError(payload, "gear_deals_click_failed", response.status);
  }

  return payload || {};
}

export { API_BASE };
